import React from "react";
import "../all css/videocounselling.css";
import { useNavigate } from "react-router-dom";
const vdo_gif = require("../../assets/vdo_counselling.gif");

function VideoCounselling(props) {
  const navigate = useNavigate();
  return (
    <section className="video_counselling_main_container">
      <div className="study_destination_under_main_container">
        <div className="study_destination_title_sub_container">
          <p
            className="title_text wow pulse animated"
            data-wow-delay="500ms"
            data-wow-iteration="infinite"
            data-wow-duration="1s"
          >
            LET'S GET CONNECTED
          </p>
        </div>

        <div className="vdo_counselling_content_gif_container">
          <div className="left_vdo_counselling_container">
            <p className="vdo_title_counselling_text">
            Dedicated and personalized support at your convenience  
            </p>
            <p className="extra_content_vdo_counselling_text">
            Experienced, Encouraging & Earnest and three words that best describe our counselling team. We are transforming the traditional method of  face to face counselling and bringing it to the comfort of your home.</p>
             <p className="extra_content_vdo_counselling_text"> CONNNECT NOW for your video counselling session. </p>
            <div className="read_more_vdo_counselling_btn_container">
              <button
                className="read_more_btn_vdo_counselling"
                onClick={() => navigate("/BookCounselling")}
              >
                CONNECT NOW
              </button>
            </div>
          </div>

          <div className="right_vdo_counselling_container">
            <div className="vdo_counselling_container">
              <img
                src={vdo_gif}
                alt="vdo_counselling"
                className="vdo_counselling_gif_self"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoCounselling;
